import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <TopicsSection />
        <MediaSection />
        <ContactSection />
        <AppSection />
        <FeaturesSection />
        <CarouselSection />
        <CommentsSection />
        <UpdatesSection />
        <CardsSection />
        <IndexSection />
        <AboutSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}